<template>
  <div >
    <div id="getMapContainer"
         class="getMapContainer">
      <div class="sousuo">
        <el-select
            v-model="souSuo"
            filterable
            remote
            style="width:300px"
            reserve-keyword
            @change="souSuoChange"
            placeholder="请输入关键词"
            :remote-method="querySearchAsync"
            :loading="loading">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.cityname+'-'+item.adname+'-'+item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="dingWei"
           @click="getGeolocation"
           :class="{dingWeiLoading:dingWeiLoading}"></div>
    </div>
    <div  class="dialog-footer" style="text-align:right;margin-top:20px">
      <el-button type="primary" @click="$emit('getLngLat',lng,lat,address)">确定</el-button>
	  <el-button @click="$emit('close')">取消</el-button>
    </div>
  </div>

</template>
<script>
export default {
  data () {
    return {
      loading:false,
      options:[],
      souSuo:'',
      geolocation: null,
      dingWeiLoading: false,
      lng: null,
      lat: null,
      address: null
    }
  },
  // [lng,lat]
  props: ['Mapcenter'],
  watch: {
    Mapcenter (val) {
      console.log('Mapcenter',val)
      if (val && val.length == 2) {
        this.setMarker(val[0], val[1])
      }
    }
  },
  mounted () {
    this.options = [];
    this.souSuo = []
    this.init()
  },
  methods: {
    souSuoChange(val){
      console.log(val)
      this.options.forEach(ele=>{
        if(ele.id == val){
          this.setMarker(ele.location.lng,ele.location.lat)
        }
      })
    },
    querySearchAsync(queryString, cb) {
      this.loading = true;
      let that = this;
      // AMap.plugin('AMap.Autocomplete', function(){
      //   // 实例化Autocomplete
      //   var autoOptions = {
      //     //city 限定城市，默认全国
      //     city: '杭州',
      //   }
      //   var autoComplete= new AMap.Autocomplete(autoOptions);
      //   autoComplete.search(queryString, function(status, result) {
      //     // 搜索成功时，result即是对应的匹配数据
      //     console.log(result)
      //     that.options = result.tips;
      //     that.loading = false;
      //   })
      // })

      AMap.plugin(['AMap.PlaceSearch'], function() {
        var PlaceSearchOptions = { //设置PlaceSearch属性
          city: "杭州", //城市
          type: "", //数据类别
          pageSize: 50, //每页结果数,默认10
          pageIndex: 1, //请求页码，默认1
          extensions: "all" //返回信息详略all，默认为base（基本信息）
        };
        var MSearch = new AMap.PlaceSearch(PlaceSearchOptions); //构造PlaceSearch类
        AMap.event.addListener(MSearch, "complete", (result)=>{
          console.log('search',result)
          that.options = result.poiList.pois;
              that.loading = false;
        }); //返回结果
        MSearch.search(queryString); //关键字查询
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    init () {
      let that = this;
      let map = new AMap.Map('getMapContainer', {
        zoom: 14,
        layers: [
          // 卫星
          new AMap.TileLayer.Satellite(),
          // 路网
          new AMap.TileLayer.RoadNet()
        ],
      });
      this.map = map
      if (!this.Mapcenter) {
        this.getGeolocation()
      } else {
        this.setMarker(this.Mapcenter[0], this.Mapcenter[1])
      }

      this.map.on('click', function (e) {
        // console.log(e);
        that.setMarker(e.lnglat.lng, e.lnglat.lat)
      })
    },
    getGeolocation () {
      let that = this;
      that.dingWeiLoading = true;
      AMap.plugin('AMap.Geolocation', function () {
        that.geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量
          offset: [10, 20],
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          position: 'RB'
        })

        that.geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        });

        function onComplete (data) {
          // data是具体的定位信息
          that.setMarker(data.position.lng, data.position.lat)
          that.dingWeiLoading = false;
        }

        function onError (data) {
          // 定位出错
          that.dingWeiLoading = false;
        }
      })

    },
    setMarker (lng, lat) {
      if (lng && lat) {
        let that = this;
        that.map.clearMap()
        that.lng = lng; //设置经度
        that.lat = lat; //设置维度
        let marker = new AMap.Marker({
          position: new AMap.LngLat(Number(lng), Number(lat)),
          offset: new AMap.Pixel(-13, -30)
        });
        that.map.add(marker)
        // 根据经纬度获得详细地址
        function getPositionByLonLats (lng, lat) {
          // console.log("经度："+lng+"纬度"+lat);
          var lnglatXY = [lng, lat];// 地图上所标点的坐标
          AMap.service('AMap.Geocoder', function () {// 回调函数
            let geocoder = new AMap.Geocoder({});
            geocoder.getAddress(lnglatXY, function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                // console.log(result.regeocode.formattedAddress);
                let address = result.regeocode.formattedAddress;
                // console.log(lng, lat, address);
                that.map.setCenter([Number(lng), Number(lat)]);
                // that.$emit("getLngLat", lng, lat, );
                that.address = address
              } else {
              }
            });
          });
        }
        getPositionByLonLats(lng, lat)
      }
    },
  }
}
//Tips:setup()是函数，具有return，return函数中定义的变量，把其暴露给模板。
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.getMapContainer {
  width: 100%;
  height: 400px;
  position: relative;
}
.dingWei {
  background: #fff
    url(https://webapi.amap.com/theme/v1.3/markers/b/loc_gray.png) 50% 50%
    no-repeat;
  width: 35px;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 3px;
  z-index: 999;
  position: absolute;
  left: 20px;
  top: 350px;
}
.sousuo{
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 999;
}
.dingWeiLoading {
  background: #fff url(https://webapi.amap.com/theme/v1.3/loading.gif) 50% 50%
    no-repeat;
}
</style>
